import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useState } from 'react';

import { pusdtAgreementBunja } from '@flipster/features/src/earn-page/get-premium-usdt/bunja';
import TermsAndConditions from '@flipster/features/src/earn-page/get-premium-usdt/terms-and-conditions';
import { Button, Checkbox } from '@flipster/react/design-system';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { useBreakpoint } from '@flipster/react/misc/responsive';
import { center, flex } from '@flipster/styled-system/patterns';
import { PusdtDisplayName } from '@flipster/utils/constants/currency';

interface Props {
  goToInfo: () => void;
  onClose: () => void;
}

const TermsStep = ({ goToInfo, onClose }: Props) => {
  const { isMobile } = useBreakpoint();

  const { isAgreedPusdtAtom, postAgreementApiAtom } = useBunja(pusdtAgreementBunja);
  const { mutateAsync } = useAtomValue(postAgreementApiAtom);
  const isAgreedPusdt = useAtomValue(isAgreedPusdtAtom);

  const [checkAgree, setCheckAgree] = useState(false);

  return (
    <>
      <Modal.Header css={{ textStyle: 'Title/M', color: 'content.default.level-4', pb: 12 }}>
        {isMobile ? 'T&C' : `${PusdtDisplayName} terms and conditions`}
      </Modal.Header>
      <Modal.Content>
        <TermsAndConditions />
      </Modal.Content>
      <Modal.Footer css={{ flexDir: 'column', gap: 16 }}>
        {!isAgreedPusdt && (
          <div className={flex({ align: 'center', justify: 'center' })}>
            <Checkbox
              css={{ color: 'content.default.level-4', p: 0 }}
              checked={checkAgree}
              onChange={(e) => setCheckAgree(e.target.checked)}
            >
              I have read and agree to the {PusdtDisplayName} terms and conditions.
            </Checkbox>
          </div>
        )}
        <div className={center()}>
          <Button
            label={isAgreedPusdt ? 'Back' : 'Continue'}
            disabled={!(checkAgree || isAgreedPusdt)}
            onClick={async () => {
              if (isAgreedPusdt) {
                goToInfo();
                return;
              }
              await mutateAsync({ agree: 'AGREEMENT_PREMIUM_USDT' });
              onClose();
            }}
            css={{ w: { base: '100%', tablet: 180 } }}
          />
        </div>
      </Modal.Footer>
    </>
  );
};

export default TermsStep;
